var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextSizeColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.667 13.333V4.667H1.334v-2H10v2H6.667v8.666h-2zm6 0V8h-2V6h6v2h-2v5.333h-2z",
    fill: "#500D76"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextSizeColor);
export default __webpack_public_path__ + "static/media/textSizeColor.d1e8f345212af25c3d48c40a225c2ed1.svg";
export { ForwardRef as ReactComponent };